import { observer } from 'mobx-react-lite';
import { FC, MutableRefObject } from 'react';

import { PopoverMenu } from '@gem/ui-kit';

import { useSubmitButtonMenuPresenter } from './SubmitButtonMenu.presenter';

interface SubmitButtonMenuProps {
  reference: MutableRefObject<HTMLButtonElement | null>;
  onSetDisabled(isDisabled: boolean): void;
  onClose(): void;
}

export const SubmitButtonMenu: FC<SubmitButtonMenuProps> = observer((props) => {
  const { reference, onClose, onSetDisabled } = props;
  const presenter = useSubmitButtonMenuPresenter(onSetDisabled);

  return (
    <PopoverMenu
      isOpened={true}
      placement="top-start"
      menuItems={presenter.menuItems}
      reference={reference.current}
      onClose={onClose}
    />
  );
});
